export default function humanTime(time, dataOnly) {
  if (dataOnly === void 0) {
    dataOnly = true;
  }
  let d = dayjs(time);
  const now = dayjs();
  if (d.isAfter(now)) {
    d = now;
  }
  const day = 864e5;
  const diff = d.diff(dayjs());
  let ago = "";
  if (diff < -30 * day) {
    if (d.year() === dayjs().year()) {
      ago = d.format(dataOnly ? 'LL' : 'LLL');
    } else {
      ago = d.format(dataOnly ? 'LL' : 'LLL');
    }
  } else {
    ago = d.fromNow();
  }
  return ago;
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/humanTime', humanTime);